import React from 'react';
import styled from 'styled-components';
import icCheckbox from './ic_checkbox.svg';
import icCheckboxChecked from './ic_checkbox-active.svg';
import { get } from 'lodash';
import Box from 'components/Box';
import CheckBoxUI from './Checkbox';

const IconCheck = ({ fill = '#E5E6EB' }: { fill?: string }) => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0161 22.5C12.6159 22.5 12.2357 22.3326 11.9555 22.0396L6.29264 16.117C5.71235 15.5101 5.71235 14.5056 6.29264 13.8987C6.87292 13.2918 7.8334 13.2918 8.41369 13.8987L13.0161 18.7121L23.3012 7.95518C23.8814 7.34827 24.8419 7.34827 25.4222 7.95518C26.0025 8.56209 26.0025 9.56662 25.4222 10.1735L14.0766 22.0396C13.7965 22.3326 13.4163 22.5 13.0161 22.5Z" fill={fill} />
  </svg>
);
const configs = {
  request: {
    label: 'Request Staff',
    fill: '#D2464F',
  },
  'none-request': {
    label: 'None-request',
    fill: '#B67650',
  },
  online: {
    label: 'Online',
    fill: '#FF7D00',
  },
};

type Props = {
  value?: 'request' | 'none-request' | 'online';
  onChange?: (value: 'request' | 'none-request' | 'online') => void;
  small?: boolean;
  icon?: boolean;
  service?: boolean;
  quickBookV2?: boolean;
};
const AptStatusHandler = ({ value, onChange, small, quickBookV2, icon, service }: Props) => {

  const onChangeStatus = (value: 'request' | 'none-request' | 'online') => () => onChange?.(value);
  if (service) return (
    <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={{ zoom: 0.7 }}>
      <CheckBoxUI small type='request' value={value === 'request'} onClick={onChangeStatus(value === 'request' ? 'none-request' : 'request')} />
    </Box>
  );
  if (icon) return (
    <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={{ zoom: 0.7 }}>
      <CheckBoxUI icon type='request' value={value === 'request'} onClick={onChangeStatus(value === 'request' ? 'none-request' : 'request')} />
    </Box>
  );
  if (quickBookV2) {
    return (
      <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={{ zoom: 0.7 }}>
        <CheckBoxUI small type='request' value={value === 'request'} onClick={onChangeStatus(value === 'request' ? 'none-request' : 'request')} />
      </Box>
    );
  }
  if (small) {
    return (
      <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={small ? { zoom: 0.75 } : {}}>
        <CheckBoxUI small={small} type='request' value={value === 'request'} onClick={() => onChange?.(value === 'request' ? 'none-request' : 'request')} />
        <CheckBoxUI small={small} type='online' value={value === 'online'} onClick={onChangeStatus('online')} />
      </Box>
    );
  }
  return (
    <Box display='flex' alignItems='center' justifyContent='end' alignSelf='stretch' gap={'2'} style={small ? { zoom: 0.75 } : {}}>
      <CheckBoxUI small={small} type='request' value={value === 'request'} onClick={onChangeStatus('request')} />
      <CheckBoxUI small={small} type='none-request' value={value === 'none-request'} onClick={onChangeStatus('none-request')} />
      <CheckBoxUI small={small} type='online' value={value === 'online'} onClick={onChangeStatus('online')} />
    </Box>
  );
};
export default AptStatusHandler;

const Container = styled.label`
  display: flex;
  align-items: center;
  .request-staff-container {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #D2464F;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
    .request-staff-container-icon {
      width: 40px;
      height: 40px;
      aspect-ratio: 1/1;
      border-radius: 100px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .request-staff-container-item {
      span {
        color: #fff;
        font-family: Poppins;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }
`;